import React, { useEffect } from "react";
import { useAuth } from "../../../../utils/AuthContext";
import AuthenticatedWishlist from "../../../../features/userDashboard/wishlist/AuthenticatedWishlist";
import GuestWishlist from "../../../../features/userDashboard/wishlist/GuestWishlist";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Dashboard from "../../Dashboard";

function Wishlist() {
  const { isLoggedIn, user } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (isLoggedIn && user && user?.role === 1) {
      history.push("/admin/dashboard");
    }
  }, [history, isLoggedIn, user]);
  if (isLoggedIn) {
    return (
      <Dashboard>
        <AuthenticatedWishlist />
      </Dashboard>
    );
  }

  return <GuestWishlist />;
}

export default Wishlist;
